// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"95":"aa758fe7","168":"4227514c","289":"65735eb8","388":"b17e765e","501":"b8085df3","613":"b6753e36","696":"948f52bd","728":"c2beef9f","911":"458d02fc","936":"320e61b0"}[chunkId] + ".js";
};